import { useTranslation } from 'react-i18next';

import { IconBell } from './icons';

/**
 * A still of the real dashboard, hand-built rather than screenshotted so it stays translated, works
 * in dark mode and cannot go stale against the UI. The figures are golden scenario A from
 * docs/ENGINE.md — the numbers the engine actually produces for a 4 000 EUR month on the minimum
 * base — so nothing on the landing page is invented.
 *
 * The two cards float outside the panel on purpose: without them the hero reads as one flat
 * rectangle on a dark background.
 */
export function HeroMock() {
  const { t } = useTranslation();

  return (
    <div className="l-mock-wrap" aria-hidden="true">
      <div className="l-float l-float--reminder">
        <span className="l-float-icon">
          <IconBell size={16} />
        </span>
        <span>
          <strong>{t('marketing.mock.reminderTitle')}</strong>
          <span>{t('marketing.mock.reminderBody')}</span>
        </span>
      </div>

      <div className="l-mock">
        <div className="l-mock-head">
          <span className="l-mock-dot" />
          <span className="l-mock-dot" />
          <span className="l-mock-dot" />
          <span className="l-mock-title">{t('marketing.mock.title')}</span>
        </div>

        <div className="l-mock-stats">
          <div className="l-mock-stat">
            <span>{t('marketing.mock.contributions')}</span>
            <strong>153,08 €</strong>
            <em>299,40 лв.</em>
          </div>
          <div className="l-mock-stat">
            <span>{t('marketing.mock.advanceTax')}</span>
            <strong>854,08 €</strong>
            <em>1 670,44 лв.</em>
          </div>
          <div className="l-mock-stat">
            <span>{t('marketing.mock.base')}</span>
            <strong>550,66 €</strong>
            <em>1 077,00 лв.</em>
          </div>
        </div>

        <span className="l-mock-pill">{t('marketing.mock.upcoming')}</span>

        <ul className="l-mock-list">
          <li>
            <span className="l-mock-icon">Д1</span>
            <span className="l-mock-name">
              {t('calendar.types.D1Monthly')}
              <em>25.02.2026</em>
            </span>
            <span className="l-mock-amount">—</span>
          </li>
          <li>
            <span className="l-mock-icon">€</span>
            <span className="l-mock-name">
              {t('calendar.types.ContributionPayment')}
              <em>25.02.2026</em>
            </span>
            <span className="l-mock-amount">153,08 €</span>
          </li>
          <li>
            <span className="l-mock-icon">55</span>
            <span className="l-mock-name">
              {t('calendar.types.D55Quarterly')}
              <em>30.04.2026</em>
            </span>
            <span className="l-mock-amount">854,08 €</span>
          </li>
        </ul>
      </div>

      <div className="l-float l-float--saving">
        <span className="l-float-big">7 306,28 €</span>
        <span>{t('marketing.mock.yearTotal')}</span>
      </div>
    </div>
  );
}
